import { useQuery } from "@tanstack/react-query";
import apiFetch from "../../utils/apiFetch";
import { authHeaders } from "./helpers";
import type { T4SummaryData } from "./types";

export function useT4SummaryPreview(year: number) {
  return useQuery<T4SummaryData>({
    queryKey: ["t4-sum-preview", year],
    queryFn: async () => {
      const r = await apiFetch(
        "/api/v1/payroll/taxes/t4-sum-preview?year=" + year,
        { headers: authHeaders() }
      );
      if (!r.ok) throw new Error("HTTP " + r.status);
      return (await r.json()) as T4SummaryData;
    },
    enabled: !!year,
    refetchOnWindowFocus: false,
  });
}